import BitcoinSvg from "assets/images/PaymentMethods/BitcoinSvg";
import LitecoinSvg from "assets/images/PaymentMethods/LitecoinSvg";
// import QiwiSvg from "assets/images/PaymentMethods/QiwiSvg";
import TronSvg from "assets/images/PaymentMethods/TronSvg";
import UsdtSvg from "assets/images/PaymentMethods/UsdtSvg";

export type PaymentMethod = {
  id: number;
  abbr: string;
  name: string;
  image: JSX.Element;
  network: any;
  isSelected: boolean;
  handleOnClick?: () => void;
};

export const paymentMethods: PaymentMethod[] = [
  // {
  //   id: 0,
  //   abbr: "qiwi",
  //   name: "Qiwi",
  //   image: <QiwiSvg />,
  //   network: "qiwi",
  //   isSelected: false,
  // },
  {
    id: 1,
    abbr: "usdt",
    name: "USDT",
    image: <UsdtSvg />,
    network: "tron",
    isSelected: false,
  },
  {
    id: 2,
    abbr: "trx",
    name: "Tron",
    image: <TronSvg />,
    network: "tron",
    isSelected: false,
  },
  {
    id: 3,
    abbr: "btc",
    name: "Bitcoin",
    image: <BitcoinSvg />,
    network: "bitcoin",
    isSelected: false,
  },
  {
    id: 4,
    abbr: "ltc",
    name: "Litecoin",
    image: <LitecoinSvg />,
    network: "litecoin",
    isSelected: false,
  },
];
